import { shoppingCartVar } from '../cache'
import { updateClientCartItemsOnStoreChange } from './update-cart-items-with-availability'

export const shoppingCartMutations = {
  updateClientCartItemsOnStoreChange: updateClientCartItemsOnStoreChange(shoppingCartVar),
}
